/* hp26 v3 (1 Oct 2026): reveal-on-scroll for homepage sections. Vanilla, deferred, ~0.6 KB.
   Only sections that start below the fold are hidden, so nothing visible on load moves (no CLS, no LCP impact).
   Skipped entirely for prefers-reduced-motion or browsers without IntersectionObserver. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.hp26-rv');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
  var vh = window.innerHeight || 800;
  for (var i = 0; i < els.length; i++) {
    var el = els[i];
    if (el.getBoundingClientRect().top < vh) continue;
    el.classList.add('hp26-rv--wait');
    io.observe(el);
  }
})();
